import axios from "axios";
import store from "../../store/index";
import Multiselect from "@vueform/multiselect";
import customModal from "../customModal/customModal.vue";
import { interpolate } from "d3";
import { type } from "jquery";

export default {
    name: 'manageDocRecipient',
    components: {
        customModal,
        Multiselect,
    },
    props: {
        documentStorageId: {
            type: String,
            default: "",
        },
        documentVersionId: {
            type: String,
            default: "",
        },
        docVersion: {
            type: String,
            default: "",
        },
        documentId: {
            type: String,
            default: "",
        }
    },
    data() {
        return {
            message: "Manage Document Recipient Component",
            baseurl: process.env.VUE_APP_Service_URL,
            IsOrderedSigning: false,
            roleList: [],
            userList: [],
            selectedRoles: [],
            selectedusers: [],
            designation: "",
            value: {
                studyId: "",
                documentId: "",
                documentVersion:"",
                emailSubject: "Document for Your Review and Signature",
                recipients: []
            },
            externalUsers: [],
            internalUsers: [],
            selectedUser: {},
            activeusers: [],
            loadingDocUpload: false
        };
    },
    watch: {
        userList(newVal) {
            this.selectedUser = {};
            newVal.forEach(user => {
                this.selectedUser[user.userID] = {
                    selected: false,
                    signOrder: 1,
                };
            });
        }
    },
    async mounted() {
        console.log("Manage Document Recipient Component mounted.", this.documentStorageId, this.documentVersionId);
        await this.getRoleList();
    },
    methods: {
            // ...keep your other methods

            validateSignOrders() {
                if (!this.IsOrderedSigning) return { ok: true }

                const orders = []
                // Collect orders from currently selected users, normalizing to integers >= 1
                Object.values(this.selectedUser || {}).forEach((entry) => {
                    if (entry && entry.selected) {
                        const n = Math.max(1, Math.floor(Number(entry.signOrder) || 1))
                        entry.signOrder = n // normalize in-place so UI stays consistent
                        orders.push(n)
                    }
                })

                if (orders.length === 0) return { ok: true } // nothing to validate

                // unique + sorted
                const uniq = Array.from(new Set(orders)).sort((a, b) => a - b)
                const min = uniq[0]
                const max = uniq[uniq.length - 1]

                // must start at 1 and be contiguous up to max (no gaps)
                if (min !== 1) {
                    return { ok: false, missing: [1], reason: 'Orders must start at 1' }
                }

                const set = new Set(uniq)
                const missing = []
                for (let i = 1; i <= max; i++) {
                    if (!set.has(i)) missing.push(i)
                }

                return missing.length ? { ok: false, missing } : { ok: true }
            },

        normalizeSignOrder(userId) {
            const e = this.selectedUser?.[userId]
            if (!e) return
            e.signOrder = Math.max(1, Math.floor(Number(e.signOrder) || 1))
        },
        deletesigner(userid) {
            const entry = this.selectedUser?.[userid]
            if (!entry) return
            entry.selected = false

            this.selectedusers = (Array.isArray(this.selectedusers) ? this.selectedusers : [])
                .filter(id => id !== userid)

            this.internalUsers = (this.internalUsers || []).filter(u => u.recipientUserId !== userid)

            entry.signOrder = 1
        },
        roleSearchFilter(option, query) {
            const q = (query || '').toString().trim().toLowerCase()
            const get = (k) => (option && option[k] != null ? String(option[k]).toLowerCase() : '')
            // Searches roleName, and if present also description/code (safe even if missing)
            return ['roleName', 'description', 'code'].some((k) => get(k).includes(q))
        },
        searchFilter(option, query) {
            const q = (query || '').toString().trim().toLowerCase()
            const name = ((option && option.name) || '').toString().toLowerCase()
            const email = ((option && option.email) || '').toString().toLowerCase()
            return name.includes(q) || email.includes(q)
        },
        closeRecipientModal() {
            this.$emit('closeRecipientModal');
        },
        async onClear() {
            this.selectedRoles = [];
            this.userList = [];
        },
        async roleChanged() {
            console.log("roleChanged", this.selectedRoles);
            let roleIds = "";
            if (this.selectedRoles && this.selectedRoles.length > 0) {
                roleIds = this.selectedRoles.join(",");
            }
            await this.getRoleBasedUserlist(roleIds);
        },
        async getRoleList() {
            const idtoken = store.getters.getIdToken;
            axios
                .get(
                    `${this.baseurl}/account-core/roles/rolelist`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                ).then((res) => {
                    this.roleList = res.data;
                })
        },
        async getRoleBasedUserlist(roleIds) {
            this.userList = [];
            const idtoken = store.getters.getIdToken;
            if (this.selectedRoles && this.selectedRoles.length > 0) {
                axios
                    .get(
                        `${this.baseurl}/account-core/user/getusersbyrole?roleids=${roleIds}&&studyid=${store.getters.getStudyIs}`, {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    })
                    .then((res) => {
                        this.userList = res.data;
                        this.userList.sort((a, b) => a.name.localeCompare(b.name));
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
            else {
                this.userList = [];
            }
        },
        async addExternalUser() {
            this.externalUsers.push({
                recipientName: "",
                recipientUserId: "",
                recipientEmail: "",
                recipientSignOrder: 1,
            });
        },
        async removeExternalUser(index) {
            this.externalUsers.splice(index, 1);
        },
        async createDocuSign() {
            const val = this.validateSignOrders()
                if (!val.ok) {
                    const msg = val.missing?.length
                    ? `Invalid sign order: missing ${val.missing.join(', ')}. Please fix the gap.`
                    : (val.reason || 'Invalid sign order.')
                    alert(msg) // or your toast/modal
                    return
                }
                this.loadingDocUpload = true;
            await this.setupinternalusers();
            const idtoken = store.getters.getIdToken;
            await this.mapValues();
            if (this.value.emailSubject == "" || this.value.emailSubject == null) {
                this.value.emailSubject = "Document for Your Review and Signature";
            }
            console.log("CREATE docusign structure", this.value);
            await axios.post(`${this.baseurl}/etmf/docusign/createdocusign`, this.value, {
                headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                },
            }).then((res) => {
                console.log("DocuSign created successfully");
                this.loadingDocUpload = false;
                this.$emit("docuSignCreated", {
                    envelopeId: res.data.envelopeId,
                    embeddedUrl: res.data.senderViewUrl
                });
            }).catch((err) => {
                console.log(err);
                this.loadingDocUpload = false;
            });
        },
        async userchanged() {
            const selectedIds = new Set(Array.isArray(this.selectedusers) ? this.selectedusers : [])
            this.userList.forEach(u => {
                if (!this.selectedUser[u.userID]) {
                    // Vue 2: this.$set(this.selectedUser, u.userID, { selected: false, signOrder: 1 })
                    this.selectedUser[u.userID] = { selected: false, signOrder: 1 } // Vue 3
                }
                this.selectedUser[u.userID].selected = selectedIds.has(u.userID)
                // keep default as 1 unless you manually change it
                if (!this.selectedUser[u.userID].signOrder) this.selectedUser[u.userID].signOrder = 1
            })
        },
        async setupinternalusers() {
            this.internalUsers = [] // reset
            this.userList.forEach((user) => this.changeInternalUser(user))
        },
        async changeInternalUser(user) {
            const entry = this.selectedUser[user.userID]
            if (entry && entry.selected) {
                this.internalUsers.push({
                    recipientName: user.name,
                    recipientUserId: user.userID,
                    recipientEmail: user.email,
                    recipientSignOrder: this.IsOrderedSigning
                        ? (entry.signOrder || 1)  // default stays 1
                        : 1,
                })
            } else {
                this.internalUsers = this.internalUsers.filter(u => u.recipientUserId !== user.userID)
            }
        },

        async mapValues() {
            console.log("Mapping Values", this.documentStorageId, this.documentVersionId);
            this.value = {
                studyId: store.getters.getStudyIs,
                documentId: this.documentId,
                documentVersion: this.docVersion,
                emailSubject: this.value.emailSubject == "" ? "Document for Your Review and Signature" : this.value.emailSubject,
                recipients: this.internalUsers.concat(this.externalUsers)
            };
        }
    }

}